module.exports = __webpack_public_path__ + "static/media/android.6674bdc7.svg";